
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { CheckIcon } from "lucide-react";
import { practiceAreas } from "../formSchema";

interface PracticeAreaSelectorProps {
  form: UseFormReturn<any>;
}

export function PracticeAreaSelector({ form }: PracticeAreaSelectorProps) {
  const togglePracticeArea = (value: string) => {
    const current = form.getValues("practiceAreas");
    let updated: string[];
    
    if (current.includes(value)) {
      updated = current.filter(item => item !== value);
    } else {
      updated = [...current, value];
    }
    
    form.setValue("practiceAreas", updated, { shouldValidate: true });
  };

  return (
    <FormField
      control={form.control}
      name="practiceAreas"
      render={() => (
        <FormItem>
          <FormLabel>Practice Areas <span className="text-red-500">*</span></FormLabel>
          <FormDescription>Select all practice areas that apply to your firm</FormDescription>
          <FormControl>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
              {practiceAreas.map((area) => {
                const isSelected = form.getValues("practiceAreas").includes(area.value);
                return (
                  <div
                    key={area.value}
                    className={`p-2 border rounded-md cursor-pointer flex items-center space-x-2 
                      ${isSelected ? "border-primary bg-primary/10" : "border-border"}`}
                    onClick={() => togglePracticeArea(area.value)}
                  >
                    {isSelected && (
                      <CheckIcon className="h-4 w-4 text-primary" />
                    )}
                    <span>{area.label}</span>
                  </div>
                );
              })}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
